/**
 * react-router-dom v7.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

// index.ts
import { HydratedRouter, RouterProvider } from "react-router/dom";
export * from "react-router";
export {
  HydratedRouter,
  RouterProvider
};
